import { PagingResultsViewModel, FilterSearchingBaseViewModel } from "../../../core/_infrastructure/types/common";

export class RegInstalacionItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: RegInstalacionItemViewModel[];
}

export class RegInstalacionItemViewModel {

    public Id: number;

    public Identificador: string = '';

    public Operador: string = '';

    public NumRegistro: string = '';

    public IdTipoInstalacionDescripcion: string = '';

    public IdTipoInstalacion: number;

    public IdProvinciaDescripcion: string = '';

    public IdProvincia: number;

    public Direccion: string = '';

    public Localidad: string = '';

    public CodigoPostal: string = '';

    public Telefono: string = '';

    public Email: string = '';

    public TecnicoResponsable: string = '';

    public Observaciones: string = '';

    public FechaAlta: Date;

    public FechaBaja: Date | null = null;

    public Baja: boolean = false;
}

export class FilterSearchingRegInstalacionViewModel extends FilterSearchingBaseViewModel {

    public Id: number;

    public Identificador: string = '';

    public Operador: string = '';

    public NumRegistro: string = '';

    public IdTipoInstalacion: number | null;

    public IdProvincia: number | null;

    public Telefono: string = '';

    public Email: string = '';

    public TecnicoResponsable: string = '';

    public Baja: boolean = false;
}

export class RegInstalacionViewModel {

    public Id: number;

    public Identificador: string = '';

    public Operador: string = '';

    public NumRegistro: string = '';

    public IdTipoInstalacion: number;

    public IdProvincia: number;

    public Direccion: string = '';

    public Localidad: string = '';

    public CodigoPostal: string = '';

    public Telefono: string = '';

    public Email: string = '';

    public TecnicoResponsable: string = '';

    public Observaciones: string = '';

    //public FechaAlta: Date;

    //public FechaBaja: Date | null;

    //public Baja: boolean = false;
}


